import React from 'react'

const Line = () => (
  <div className="timeline-line" />
)

export default Line
